import { render } from "./TourDialog.vue?vue&type=template&id=65c00ef3"
import script from "./TourDialog.vue?vue&type=script&lang=js"
export * from "./TourDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__